// src/services/api.js
const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://chinese-master.vercel.app/api';

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  async request(endpoint, options = {}) {
    const token = localStorage.getItem('token');
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` })
      },
      ...options
    };

    try {
      const response = await fetch(`${this.baseURL}${endpoint}`, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('API Request Error:', error);
      throw error;
    }
  }

  async login(credentials) {
    return this.request('/auth/login', {
      method: 'POST',
      body: JSON.stringify(credentials)
    });
  }

  async register(userData) {
    return this.request('/auth/register', {
      method: 'POST',
      body: JSON.stringify(userData)
    });
  }

  async getUserProfile() {
    return this.request('/user/profile');
  }

  async updateProgress(progressData) {
    return this.request('/user/progress', {
      method: 'PUT',
      body: JSON.stringify(progressData)
    });
  }

  async getVocabulary(filters = {}) {
    const params = new URLSearchParams(filters).toString();
    const endpoint = params ? `/vocabulary?${params}` : '/vocabulary';
    return this.request(endpoint);
  }

  async saveWordProgress(wordData) {
    return this.request('/vocabulary/progress', {
      method: 'POST',
      body: JSON.stringify(wordData)
    });
  }
}

const apiService = new ApiService();
export default apiService;